import React from 'react'

const EvaluationScheduleIconBlue = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.89 3 5 3H6V1H8V3H16V1H18V3ZM7 10H17V12H7V10ZM19 19H5V8H19V19ZM7 14H14V16H7V14Z"
        fill="#3249D7"
      />
    </svg>
  )
}

export default EvaluationScheduleIconBlue
